// extracted by mini-css-extract-plugin
module.exports = {"title":"_1IHCFul","loginComment":"_W92eP7I","crm":"_12mJj-5","tooltipIcon":"_2ycwhJv","tooltip":"_i-_r0JS","error":"_2KJViNZ"};